// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"548":"83349037","751":"cd1093b6","825":"8e4c998a","928":"7c6e1789"}[chunkId] + ".chunk.js";
};